import constants from './constants';

export const startLoader = (loader = constants.LOADER) => ({
  type: 'START_' + loader,
});
export const stopLoader = (loader = constants.LOADER) => ({ type: 'STOP_' + loader });
